



















































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { confirmRemove } from "@/utility/CommonHelper";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import AsesmenPraSedaService from "@/services/AsesmenPraSedasi";
import AsesmenPraSedasiStore from "@/store/modules/AsesmenPraSedasiStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import AsesmenPraSedaDetail from "@/components/pemeriksaan/assesmen/AsesmenPraSedaDetail.vue";

@Component({
  components: {
    CardModalTtd,
    DokterAutoComplete,
    AsesmenPraSedaDetail
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAsesmenPraSedasi extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("asesmen_pra_sedasi", "create");
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isFormOpen = false;
  ttdDialog = false;
  signRole = "dokter";
  saving = false;
  isEditing = false;
  editingId: number | null = null;
  signingItem: any = null;
  selectedDokter: any = null;
  menuTgl = false;
  menuJam = false;

  form: any = this.getEmptyForm();

  mallampatiOptions = [
    { text: "I — Uvula & pilar faring terlihat penuh", value: "I" },
    { text: "II — Uvula & pilar faring terlihat sebagian", value: "II" },
    { text: "III — Hanya palatum molle & dasar uvula", value: "III" },
    { text: "IV — Hanya palatum durum", value: "IV" }
  ];

  asaOptions = [
    { text: "ASA I — Pasien sehat", value: "I" },
    { text: "ASA II — Gangguan sistemik ringan", value: "II" },
    { text: "ASA III — Gangguan sistemik berat, tidak mengancam jiwa", value: "III" },
    { text: "ASA IV — Gangguan sistemik berat, mengancam jiwa", value: "IV" },
    { text: "ASA V — Moribund", value: "V" },
    { text: "ASA VI — Mati otak (donor organ)", value: "VI" }
  ];

  asaDescriptions: Record<string, string> = {
    I: "Pasien sehat",
    II: "Gangguan sistemik ringan",
    III: "Gangguan sistemik berat, tidak mengancam jiwa",
    IV: "Gangguan sistemik berat, mengancam jiwa",
    V: "Moribund",
    VI: "Mati otak (donor organ)"
  };

  get asaDescription(): string {
    return this.asaDescriptions[this.form.asa_klasifikasi] || "";
  }

  get vasColor(): string {
    const v = this.form.vas;
    if (v === null || v === undefined) return "grey";
    if (v <= 3) return "green";
    if (v <= 6) return "orange";
    return "red";
  }

  get dataList() {
    return AsesmenPraSedasiStore.dataList;
  }

  get loading() {
    return AsesmenPraSedasiStore.loading;
  }

  mounted() {
    if (this.isActive) {
      this.loadData();
    }
  }

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val) {
      this.loadData();
    }
  }

  async loadData() {
    await AsesmenPraSedasiStore.getByRegister(this.register);
  }

  getEmptyForm() {
    const now = moment();
    return {
      tgl_asesmen_date: now.format("YYYY-MM-DD"),
      tgl_asesmen_time: now.format("HH:mm"),
      keluhan: "", riwayat_penyakit_lain: "",
      rp_hipertensi: false, rp_penyakit_jantung: false, rp_asthma: false, rp_tbc_ppok: false,
      rp_dm: false, rp_stroke_tia: false, rp_merokok: false, rp_alergi: false,
      rp_alergi_keterangan: "", riwayat_operasi: "", riwayat_anestesi: "",
      td_sistol: null, td_diastol: null, nadi: null, laju_napas: null, suhu: null, vas: 0,
      pf_konjungtiva: "", pf_mallampati: null, pf_thorax: "", pf_abdomen: "", pf_ekstremitas: "", pf_komplikasi: "",
      pp_lab: "", pp_ekg: "", pp_rontgen: "", pp_lain: "",
      diagnosis: "", asa_klasifikasi: null, asa_emergency: false,
      rencana_tindakan: "", premedikasi: "", puasa_jam: null, persediaan_darah: "",
      teknik_sedasi: false, teknik_ga: false, teknik_spinal: false, teknik_epidural: false, teknik_kaudal: false, teknik_blok_perifer: false,
      tk_hipotensi: false, tk_ventilasi_satu_paru: false, tk_tci: false, tk_lainnya: false, tk_lainnya_text: "",
      mon_ekg: false, mon_ekg_lead: "", mon_spo2: false, mon_nibp: false, mon_temperatur: false,
      mon_arteri_line: false, mon_cvp: false, mon_etco2: false, mon_bis: false,
      pasca_anestesi: null, dokter_anestesi_id: null
    };
  }

  addNew() {
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();

    // RAN-051: prefill alergi dari data kanonik pasien (record baru).
    const alergiKanonik = storePasien.identitasPasien?.alergi;
    if (alergiKanonik && !this.form.rp_alergi_keterangan) {
      this.form.rp_alergi = true;
      this.form.rp_alergi_keterangan = alergiKanonik;
    }

    this.selectedDokter = null;
    this.isFormOpen = true;
  }

  editItem(item: any) {
    this.isEditing = true;
    this.editingId = item.id;
    const tgl = moment(item.tgl_asesmen);
    this.form = { ...item, tgl_asesmen_date: tgl.format("YYYY-MM-DD"), tgl_asesmen_time: tgl.format("HH:mm") };
    this.selectedDokter = item.dokter_anestesi
      ? { id: item.dokter_anestesi.id, nama: item.dokter_anestesi.identitas?.nama || "" }
      : null;
    this.isFormOpen = true;
  }

  closeForm() {
    this.isFormOpen = false;
    this.form = this.getEmptyForm();
    this.selectedDokter = null;
  }

  onDokterSelected(dokter: any) {
    if (dokter && dokter.id) {
      this.form.dokter_anestesi_id = dokter.id;
      this.selectedDokter = dokter;
    }
  }

  buildPayload() {
    const tglAsesmen = `${this.form.tgl_asesmen_date} ${this.form.tgl_asesmen_time}:00`;
    return {
      register_id: this.register, pasien_rm: String(this.rm), tgl_asesmen: tglAsesmen,
      keluhan: this.form.keluhan || null, riwayat_penyakit_lain: this.form.riwayat_penyakit_lain || null,
      rp_hipertensi: this.form.rp_hipertensi, rp_penyakit_jantung: this.form.rp_penyakit_jantung,
      rp_asthma: this.form.rp_asthma, rp_tbc_ppok: this.form.rp_tbc_ppok,
      rp_dm: this.form.rp_dm, rp_stroke_tia: this.form.rp_stroke_tia,
      rp_merokok: this.form.rp_merokok, rp_alergi: this.form.rp_alergi,
      rp_alergi_keterangan: this.form.rp_alergi ? this.form.rp_alergi_keterangan : null,
      riwayat_operasi: this.form.riwayat_operasi || null, riwayat_anestesi: this.form.riwayat_anestesi || null,
      td_sistol: this.form.td_sistol, td_diastol: this.form.td_diastol,
      nadi: this.form.nadi, laju_napas: this.form.laju_napas, suhu: this.form.suhu, vas: this.form.vas,
      pf_konjungtiva: this.form.pf_konjungtiva || null, pf_mallampati: this.form.pf_mallampati,
      pf_thorax: this.form.pf_thorax || null, pf_abdomen: this.form.pf_abdomen || null,
      pf_ekstremitas: this.form.pf_ekstremitas || null, pf_komplikasi: this.form.pf_komplikasi || null,
      pp_lab: this.form.pp_lab || null, pp_ekg: this.form.pp_ekg || null,
      pp_rontgen: this.form.pp_rontgen || null, pp_lain: this.form.pp_lain || null,
      diagnosis: this.form.diagnosis, asa_klasifikasi: this.form.asa_klasifikasi, asa_emergency: this.form.asa_emergency,
      rencana_tindakan: this.form.rencana_tindakan || null, premedikasi: this.form.premedikasi || null,
      puasa_jam: this.form.puasa_jam, persediaan_darah: this.form.persediaan_darah || null,
      teknik_sedasi: this.form.teknik_sedasi, teknik_ga: this.form.teknik_ga,
      teknik_spinal: this.form.teknik_spinal, teknik_epidural: this.form.teknik_epidural,
      teknik_kaudal: this.form.teknik_kaudal, teknik_blok_perifer: this.form.teknik_blok_perifer,
      tk_hipotensi: this.form.tk_hipotensi, tk_ventilasi_satu_paru: this.form.tk_ventilasi_satu_paru,
      tk_tci: this.form.tk_tci, tk_lainnya: this.form.tk_lainnya,
      tk_lainnya_text: this.form.tk_lainnya ? this.form.tk_lainnya_text : null,
      mon_ekg: this.form.mon_ekg, mon_ekg_lead: this.form.mon_ekg ? this.form.mon_ekg_lead : null,
      mon_spo2: this.form.mon_spo2, mon_nibp: this.form.mon_nibp, mon_temperatur: this.form.mon_temperatur,
      mon_arteri_line: this.form.mon_arteri_line, mon_cvp: this.form.mon_cvp,
      mon_etco2: this.form.mon_etco2, mon_bis: this.form.mon_bis,
      pasca_anestesi: this.form.pasca_anestesi, dokter_anestesi_id: this.form.dokter_anestesi_id
    };
  }

  async saveForm() {
    this.saving = true;
    try {
      const payload = this.buildPayload();
      if (this.isEditing && this.editingId) {
        await AsesmenPraSedaService.update(this.editingId, payload);
        appModule.NoticeDelay("Berhasil memperbarui Asesmen Pra Anestesi/Sedasi");
      } else {
        await AsesmenPraSedaService.create(payload);
        appModule.NoticeDelay("Berhasil menyimpan Asesmen Pra Anestesi/Sedasi");
      }
      this.closeForm();
      this.loadData();
    } catch (err) {
      // error handled by service
    } finally {
      this.saving = false;
    }
  }

  bisaHapus(item: any): boolean {
    if (this.readOnly) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        { ditandatangani: item.signed_dokter, penandaTanganId: item.dokter_anestesi_id },
        { ditandatangani: item.signed_ppja, penandaTanganId: item.ppja_user_id }
      ],
      userModule.user?.id
    );
  }

  removeItem(item: any) {
    if (!this.bisaHapus(item)) return;
    const conf = confirmRemove("Asesmen Pra Anestesi/Sedasi");
    if (conf) {
      AsesmenPraSedaService.destroy(item.id).then(resp => {
        if (resp.status == 1) {
          appModule.NoticeDelay("Berhasil menghapus Asesmen Pra Anestesi/Sedasi");
          this.loadData();
        }
      });
    }
  }

  openSign(item: any, role = "dokter") {
    this.signingItem = item;
    this.signRole = role;
    this.ttdDialog = true;
  }

  async submitSign(password: string) {
    if (!this.signingItem) return;
    const isPpja = this.signRole === "ppja";
    try {
      const resp = isPpja
        ? await AsesmenPraSedaService.signPpja(this.signingItem.id, { password })
        : await AsesmenPraSedaService.signDokter(this.signingItem.id, { password });
      if (resp.status == 1) {
        appModule.NoticeDelay(
          `Berhasil menandatangani Asesmen Pra Anestesi/Sedasi (${isPpja ? "PPJA" : "Dokter"})`
        );
        this.loadData();
      }
    } catch (err) {
      // error handled by service
    }
    this.signingItem = null;
  }

  printPdf(id: number) {
    AsesmenPraSedaService.print(id);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format("DD-MM-YYYY HH:mm");
  }

  asaColor(asa: string): string {
    if (!asa) return "grey";
    const map: Record<string, string> = { I: "green", II: "blue", III: "orange", IV: "red darken-1", V: "red darken-4", VI: "black" };
    return map[asa] || "grey";
  }

  teknikSummary(item: any): string {
    const parts: string[] = [];
    if (item.teknik_sedasi) parts.push("Sedasi");
    if (item.teknik_ga) parts.push("GA");
    if (item.teknik_spinal) parts.push("Spinal");
    if (item.teknik_epidural) parts.push("Epidural");
    if (item.teknik_kaudal) parts.push("Kaudal");
    if (item.teknik_blok_perifer) parts.push("Blok Perifer");
    return parts.join(", ");
  }
}
